import { EditMembersParams } from '@mygpt/app/collaborate/services/add-members';
import { Http } from '@mygpt/app/http';

/**
 * 删除协作者
 * @param params
 * @returns
 */
export const deleteMembersService = (params: EditMembersParams) => {
  const { delete: deleteFn } = Http.use();
  return deleteFn(`/users/members`, { data: { req: [params] } });
};

/**
 * 主动退出协作者
 * @param params
 * @returns
 */
export const leaveMembersService = (params: EditMembersParams) => {
  const { delete: deleteFn } = Http.use();
  return deleteFn(`/users/members/${params.ai_id}?resource_type=${params.resource_type}`);
};
